import { Link } from 'react-router-dom';

import Logo from "../../../../assets/img/FiaLinks_logo.svg";

import { GoCalendar } from 'react-icons/go';

import SocialMedia from '../../../../components/SocialMedia/SocialMedia';
import NewLine from '../../../../components/NewLine/NewLine';

import { useTranslation } from "react-i18next";
import html from 'html-react-parser';

const Slogan = ({ title="", description="" }) => {
    const { t } = useTranslation();

    return (
        <section className="bg-cover bg-no-repeat bg-center bg-conia-light">
            <div className="w-full max-w-3xl flex flex-col gap-4">
                <figure className='self-center w-full max-w-lg h-auto'>
                    <img src={Logo} alt="FIA Links" />
                </figure>

                <h3 className="flex gap-3 justify-center items-center text-lg md:text-xl lg:text-2xl"> 
                   <GoCalendar/> { html(t("index_dates_text")) } 
                </h3>

                <h2 className='text-center text-xl'>
                    { title }
                </h2>

                <NewLine className='text-justify whitespace-pre-line'>
                    { description }
                </NewLine>

                <Link to="/auth/signin" className='bg-primary w-full md:w-2/5 self-center
                    text-center no-underline text-conia-icons hover:text-conia-icons
                    p-2 rounded-md text-lg hover:scale-110'>
                    { t("index_subscribe_btn") }
                </Link>
                {/* <Link to="/" className='bg-primary-disabled w-full md:w-2/5 self-center
                    text-center no-underline cursor-not-allowed text-gray-600 hover:text-gray-600 
                    p-2 rounded-md text-lg select-none'>
                    { t("index_coming_soon_btn") }
                </Link> */}

                <SocialMedia className='self-center'/>
            </div>
        </section>
    );
}

export default Slogan;